import { FileRejection } from 'react-dropzone'
import React from 'react'
import { useIntl } from 'react-intl'
import { formatBytes } from '../../../services/utils'

export type DropzoneRejectionsProps = {
	fileRejections: FileRejection[]
	maxSize?: number
}
const DropzoneRejections = ({
	fileRejections,
	maxSize,
}: DropzoneRejectionsProps) => {
	const { formatMessage } = useIntl()

	if (!fileRejections?.length) {
		return null
	}
	return (
		<div className="text-xs font-black text-red-700">
			{fileRejections.map((fileRejection: FileRejection) => (
				<div
					key={`${fileRejection.file.name}__${fileRejection.file.lastModified}`}
				>
					{fileRejection.errors.map((error) => (
						<div
							key={`${fileRejection.file.name}__${fileRejection.file.lastModified}__${error.code}`}
							className="break-words"
						>
							{fileRejection.file.name}:{' '}
							{error.code === 'file-too-large' && maxSize
								? formatMessage(
										{ id: 'dropzone.file_too_large' },
										{ size: formatBytes(maxSize) }
									)
								: error.message}
						</div>
					))}
				</div>
			))}
		</div>
	)
}

export default DropzoneRejections
